/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Announcement } from '../../models/announcement';
import { ApiResponseAnnouncement } from '../../models/api-response-announcement';

export interface CreateAnnouncement$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: Announcement
}

export function createAnnouncement(http: HttpClient, rootUrl: string, params: CreateAnnouncement$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAnnouncement>> {
  const rb = new RequestBuilder(rootUrl, createAnnouncement.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseAnnouncement>;
    })
  );
}

createAnnouncement.PATH = '/v1/api/admin-ui/announcement/create';
